import { SchoolReportSectionsUIProvider } from "./SchoolReportSectionsUIContext";
import { SchoolReportSectionsCard } from "./SchoolReportSectionsCard";

export function SchoolReportSectionsPage({
  reportId,
  term,
  goNext
}) {
  return (
    <SchoolReportSectionsUIProvider term={term}>
      <SchoolReportSectionsCard
        reportId={reportId}
        goNext={goNext}
      />
    </SchoolReportSectionsUIProvider>
 );
}